export function replacer(key, value) {
  if(value instanceof Map) {
    return {
      dataType: 'Map',
      value: Array.from(value.entries()), // or with spread: value: [...value]
    };
  } else {
    return value;
  }
}

export function reviver(key, value) {
  if(typeof value === 'object' && value !== null) {
    if (value.dataType === 'Map') {
      return new Map(value.value);
    }
  }
  return value;
}

export class StorageService {
  private static _INSTANCE: StorageService;

  public static getInstance(): StorageService {
    if(!this._INSTANCE) {
      this._INSTANCE = new StorageService();
    }
    return this._INSTANCE;
  }

  // lien vers le storage
  private _storage: Storage;

  /** accesseur vers le localStorage (cache navigateur) */
  constructor() {
    this._storage = localStorage;
  }

  getString(key: string): string {
    return this._storage.getItem(key);
  }

  setString(key: string, value: string) {
    this._storage.setItem(key, value);
  }

  remove(key: string) {
    this._storage.removeItem(key);
  }

  get<T>(key: string): T {
    return JSON.parse(this._storage.getItem(key), reviver);
  }

  set<T>(key: string, value: T) {
    // console.log('storage set', key, value);
    this._storage.setItem(key, JSON.stringify(value, replacer));
  }
}
